import { useContext, useEffect, useState } from 'react';
import { FloatingWindow, FloatingWindowType } from 'types/app.types';
import MainAppContext from '../MainAppContext';
import defaultFloatingWindowsList from './defaultWindowsList';

const useFloatingWindowsState = () => {
  const { viewMode, displayAlarms } = useContext(MainAppContext);
  const storedFloatingWindowsList = localStorage.getItem(`storedFloatingWindowsList_${viewMode}`);
  const [
    floatingWindowsList,
    setFloatingWindowsList,
  ] = useState<FloatingWindow[]>(storedFloatingWindowsList
    ? JSON.parse(storedFloatingWindowsList)
    : defaultFloatingWindowsList);

  const handleSetFloatingWindowsList = (index: string, position: {top: number, left: number}) => {
    setFloatingWindowsList(
      (prev) => prev.map((p) => (p.index === index ? {
        ...p,
        top: p.top + position.top,
        left: p.left + position.left,
      } : p)),
    );
  };
  useEffect(() => {
    localStorage.setItem(`storedFloatingWindowsList_${viewMode}`, JSON.stringify(floatingWindowsList));
  }, [floatingWindowsList, viewMode]);

  useEffect(() => {
    if (!displayAlarms) {
      setFloatingWindowsList((prev) => prev
        .filter((windows) => windows.type !== FloatingWindowType.Alarms));
    } else {
      setFloatingWindowsList((prev) => [
        ...prev,
        defaultFloatingWindowsList
          .find((windows) => windows.type === FloatingWindowType.Alarms) as FloatingWindow,
      ]);
    }
  }, [displayAlarms, setFloatingWindowsList]);

  return { setFloatingWindowsList: handleSetFloatingWindowsList, floatingWindowsList };
};

export default useFloatingWindowsState;
